/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VtTurnOverRatio = {
    VT10000100: 'VT10000100',
    VT10000110: 'VT10000110',
    VT11000110: 'VT11000110',
    VT230400: 'VT230400',
    VT60000100: 'VT60000100',
    VT60000110: 'VT60000110',
    VT690400: 'VT690400',
} as const;
export type VtTurnOverRatio = typeof VtTurnOverRatio[keyof typeof VtTurnOverRatio];

